//#region import libraries
import React from 'react';

// custom components
import { NewScreen, Title } from '_atoms';
import { RegisterTileButton } from '_molecules';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

// utils
import { Spacing } from '_styles';
import { useHistory } from 'react-router-dom';

// images & icons
import { BsChevronRight } from "react-icons/bs";
import DUB from "_assets/images/profile/DUB-CIRCLE.png";
import ORK from "_assets/images/profile/ORK-CIRCLE.png";
import BFS from "_assets/images/profile/BFS-CIRCLE.png";
import BRS from "_assets/images/profile/BRS-CIRCLE.png";
import GlasgowAirport from "_assets/images/account/glasgow.jpeg";
import DonegalAirport from "_assets/images/account/CFN-CIRCLE.png";

// redux
import { setIata } from '_redux/slices/main-screen/user';
import { useDispatch } from 'react-redux';
//#endregion

const AirportSelector = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();

    const handleClick = (iata) => {
        // set global iata ////
        dispatch(setIata(iata))

        // go to calendar
        history.push('prm-calendar')
    }

    const airportLoading = false;

    return (
        <NewScreen>
            <Row>
                <Title name="" subtitle={"Select an airport"} description={"Choose an airport to filter the passenger information using that airport's iata code"} />
            </Row>
            <Row style={{}}>
                <Container className="d-flex justify-content-center">
                    <RegisterTileButton
                        title="Dublin Airport"
                        text=""
                        icon={
                            <img src={DUB} width={150} style={{ marginLeft: 5, borderRadius: '50%' }} />
                        }
                        lowerIcon={airportLoading == true ? <Circle /> : <BsChevronRight size={32} style={{ paddingTop: Spacing.SCALE_12 }} color='white' />}
                        onClick={() => handleClick('DUB')}
                    />
                    <RegisterTileButton
                        title="Cork Airport"
                        text=""
                        icon={
                            <img src={ORK} width={150} style={{ marginLeft: 5, borderRadius: '50%' }} />
                        }
                        lowerIcon={airportLoading == true ? <Circle /> : <BsChevronRight size={32} style={{ paddingTop: Spacing.SCALE_12 }} color='white' />}
                        onClick={() => handleClick('ORK')}
                    />
                    <RegisterTileButton
                        title="Bristol Airport"
                        text=""
                        icon={
                            <img src={BRS} width={150} style={{ marginLeft: 5, borderRadius: '50%' }} />
                        }
                        lowerIcon={airportLoading == true ? <Circle /> : <BsChevronRight size={32} style={{ paddingTop: Spacing.SCALE_12 }} color='white' />}
                        onClick={() => handleClick('BRS')}
                    />
                    <RegisterTileButton
                        title="Belfast Airport"
                        text=""
                        icon={
                            <img src={BFS} width={150} style={{ marginLeft: 5, borderRadius: '50%' }} />
                        }
                        lowerIcon={airportLoading == true ? <Circle /> : <BsChevronRight size={32} style={{ paddingTop: Spacing.SCALE_12 }} color='white' />}
                        onClick={() => handleClick('BFS')}
                    />
                </Container>
                <Container className="d-flex justify-content-center mt-3">
                    <RegisterTileButton
                        title="Glasgow Airport"
                        text=""
                        icon={
                            <img src={GlasgowAirport} width={150} style={{ marginLeft: 5, borderRadius: '50%' }} />
                        }
                        lowerIcon={airportLoading == true ? <Circle /> : <BsChevronRight size={32} style={{ paddingTop: Spacing.SCALE_12 }} color='white' />}
                        onClick={() => handleClick('GLA')} />

                    <RegisterTileButton
                        title="Donegal Airport"
                        text=""
                        icon={
                            <img src={DonegalAirport} width={150} style={{ marginLeft: 5, borderRadius: '50%' }} />
                        }
                        lowerIcon={airportLoading == true ? <Circle /> : <BsChevronRight size={32} style={{ paddingTop: Spacing.SCALE_12 }} color='white' />}
                        onClick={() => handleClick('CFN')} />
                </Container>
            </Row>
        </NewScreen>
    );
};

export default AirportSelector;